import { accountsLinkingSagas } from './accounts';
import { executionIdLinkingSagas } from './executionId';
import { orderIdLinkingSagas } from './orderId';
import { quantityLinkingSagas } from './quantity';
import { resetLinkingSagas } from './reset';
import { instrumentLinkingSagas, symbolLinkingSagas } from './symbols';
import { all, spawn } from 'redux-saga/effects';
import type { AppAction } from 'src/store/actions';

/**
 * List of Redux action types that should be forwarded
 * to external applications on the desktop.
 */
export const externalLinkingActionTypesList: AppAction['type'][] = [
    'updateAlphaLensSymbol',
    'userSelectedNewAlphaLensSymbol',
    'updateExecutionsInstrument',
    'updateMessagesInstrument',
    'updatePositionsInstrument',
    'userDoubleClickedPositionFromTable',
    'userSelectedNewTradeProSymbol',
    'updateOrdersInstrument',
    'userDoubleClickedOrderFromTable',
    'updateLocatesV2Symbol',
    'userSelectedNewLocatesV2Symbol',
    'updateOrderBlotterInstrument',
    'userDoubleClickedSymbolFromTable',
];

export function* linkingSagas() {
    yield all([
        spawn(resetLinkingSagas),
        spawn(accountsLinkingSagas),
        spawn(executionIdLinkingSagas),
        spawn(orderIdLinkingSagas),
        spawn(quantityLinkingSagas),
        spawn(symbolLinkingSagas),
        spawn(instrumentLinkingSagas),
    ]);
}
